import { auth } from "@/services/api"

class UsuarioService {
  static getUsuarios () {
    return auth.get('/users').then(res => {
      if (res.data && Array.isArray(res.data)) {
        res.data.forEach(usuario => {
          if (usuario.flag_oficial && !usuario.escrevente) {
            usuario.escrevente = 1
          }
        })
      }

      return res
    })
  }

  static addUsuario (params) {
    return auth.post('/users', params)
  }

  static updateUsuario (params) {
    return auth.put(`/users/${ params.user_id }`, params)
  }

  static deleteUsuario (params) {
    return auth.delete(`/users/${ params.user_id }`)
  }

  static getMyUsers () {
    // busca usuarios com o mesmo cpf do usuario logado.
    return auth.get('/search-my-users')
  }

  static changeMyUser (newUserId) {
    // busca usuarios com o mesmo cpf do usuario logado.
    return auth.post(`/change-my-user/${ newUserId }`)
  }
}

export default UsuarioService
